import axios from "axios";
import React, { useState, useEffect, Component } from 'react'
import { Button, Col, Container, Row, Badge, Modal, Form, Alert, FormLabel, Card, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navigate} from 'react-router-dom';
import CurrencyInput,{ formatValue } from 'react-currency-input-field';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {connect} from 'react-redux';
import {createTransaction, updateTransaction, getAssets, getCategories} from '../context/actions/index'
import { ArrowUpShort, ArrowDownShort, ArrowUp, ArrowDown, ArrowLeftRight } from 'react-bootstrap-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faCircleUser, faHome } from '@fortawesome/free-solid-svg-icons';
import { faReact } from '@fortawesome/free-brands-svg-icons';
import { 
  FaExchangeAlt,
    FaMoneyBillWave,
    FaWallet,
    FaArrowRight,
    FaCalendarAlt,
    FaTag,
    FaEdit,
    FaPaperPlane,
  FaArrowUp,
  FaArrowDown,
  FaFilter,
} from 'react-icons/fa';
import './transaction.css';
import Fab from "./FAB";
import {TransactionButtons, HorizontalTransactionButtons, ModalTransactionButtons} from "./transactionButtons"
import {CreateTransactionForm, TransferForm} from "./CreateTransactionForm"

//import {CreateAssetForm} from './createAsset'

class Transactions extends Component{
    
    handleClose = () => this.setState({data:'', show:false, update:false,transactionType:'', edit:false});
    handleShow = (val) => {
        const today = new Date()
        const active_month = new Date(this.props.books["active_month"])
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        if((today.getUTCMonth()!==active_month.getUTCMonth())||today.getUTCFullYear()!==active_month.getUTCFullYear()){
            //alert("tidak bisa tambah transaksi, silahkan ganti bulan buku")
            if(window.confirm(`Bulan aktif buku adalah ${monthNames[active_month.getUTCMonth()]} ${active_month.getUTCFullYear()}, ganti dengan bulan sekarang?`)){
                this.setState({redirect: true, needUpdate:"/reviewbook"})
                return;
            }else{
              this.setState({transactionType:val, show:true, });
            }
        }else{
           this.setState({transactionType:val, show:true, });
        }
        
    }
    //navigate = useNavigate()
    constructor(props){
        super(props);
		this.state ={
			show: false,
            data:'',
            reff_id:'',
            edit:false,
            transactionType:'',
            startDate: new Date(),
            redirect: false,
            needUpdate: false,
            counter:0,
            filter: 'all',
            // Tambahan state untuk filter baru
            assetFilter: 'all',
            categoryFilter: 'all',
            showFilters: false
		}
    }
    componentDidMount(){
        
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    

    CreateTransactionModal = (data) =>{
        //console.log(this.props.assets)
        if(this.props.books.month=="null"){
            
        }
        var modal
        if(this.state.transactionType=="transfer"){
            //console.log(this.props.transactions.filter(transaction => transaction.reff_id === this.state.reff_id))
            modal=(
                <Modal size="lg" contentClassName="form" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Body>
                        <TransferForm 
                        handleClose={this.handleClose} 
                        transactionType={this.state.transactionType} 
                        assets={this.props.assets} 
                        categories={this.props.categories} 
                        show={this.state.show} 
                        data={this.state.data} 
                        edit={this.state.edit} 
                        transactions={this.props.transactions.filter(transaction => transaction.reff_id === this.state.reff_id)}
                        active_month={this.props.books.active_month}
                        createTransaction={this.props.createTransaction}/>
                    </Modal.Body>
                </Modal>
            )
        }else{
            modal=(
                <Modal size="lg" contentClassName="form" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Body>
                        <CreateTransactionForm 
                        handleClose={this.handleClose} 
                        transactionType={this.state.transactionType} 
                        assets={this.props.assets} 
                        categories={this.props.categories} 
                        show={this.state.show} 
                        data={this.state.data} 
                        edit={this.state.edit} 
                        active_month={this.props.books.active_month}
                        createTransaction={this.props.createTransaction}
                        updateTransaction={this.props.updateTransaction}/>
                    </Modal.Body>
                </Modal>
            )
        }
        return(
            modal
        )
    }

    editData =(data)=>{
        const date = new Date(data.date.replace(" ", "T"));
        const active_month = new Date(this.props.books["active_month"])
        //console.log(data.transactionType)
        this.setState({data:data, reff_id : data.reff_id, edit:true})
        if(date.getUTCMonth()==active_month.getMonth()||date.getUTCFullYear()!==active_month.getUTCFullYear()){
          if(data.reff_id){
            //this.handleShow('transfer')
          }else{
            this.handleShow()
          }
            
        }else{
            alert("buku sudah ditutup, transaksi tidak bisa di edit")
        }
            
      // }
    }

    getGroupedTransactions=()=> {
        const transactions = this.props.transactions;
        //console.log(transactions)
        const grouped = {};
        
        transactions.forEach(transaction => {
        const dateOnly = transaction.date.split(' ')[0];
        
        if (!grouped[dateOnly]) {
            grouped[dateOnly] = [];
        }
        
        grouped[dateOnly].push(transaction);
        });
       
        return grouped;
    }

    // Method untuk mendapatkan aset lancar
    getAsetLancar = () => {
        return this.props.assets.filter(asset => 
            asset.type === '1' && asset.category === '1'
        );
    }

    filterTransactions(transactions) {
        let filtered = transactions;
        const { filter, assetFilter, categoryFilter } = this.state;

        // Filter berdasarkan tipe transaksi
        if (filter !== 'all') {
          if(filter !=='transfer'){
            filtered = filtered.filter(t => t.transactionType === filter);
          }else{
            
          }
        }

        // Filter berdasarkan aset
        if (assetFilter !== 'all') {
            filtered = filtered.filter(t => t.asset_id === assetFilter);
        }

        // Filter berdasarkan kategori
        if (categoryFilter !== 'all') {
            filtered = filtered.filter(t => t.category_id === categoryFilter);
        }

        return filtered;
    }

    getDailyTotal(transactions) {
        return transactions.reduce((total, transaction) => {
        const amount = parseInt(transaction.amount);
        return total + amount;
        }, 0);
    }

      // Method untuk memformat mata uang Indonesia
  formatCurrency(amount) {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(Math.abs(amount));
  }

    formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

   TimeFormatter = ({ date }) => {
    const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(new Date(date));

    return formattedTime;
    };

    calculateTotals(transactions) {
        let income = 0;
        let expense = 0;
        let transfer = 0;
        
        transactions.forEach(transaction => {
            const amount = parseInt(transaction.amount);
            
            if (transaction.amount >= 0 && transaction.reff_id == null) {
                income += amount;
            } else if (transaction.amount < 0 && transaction.reff_id == null) {
                expense += amount;
            } else if (transaction.amount >= 0 && transaction.reff_id != null) {
                transfer += Math.abs(amount);
            }
        });
        
        return { income, expense, transfer, net: income - Math.abs(expense) };
    }
    
          getTypeBadge = (transaction) => {
            //console.log(type)
            const variants = {
              1: 'success',
              2: 'danger',
              null: 'info'
            };
            
            const icons = {
              1: <FaArrowDown />,
              2: <FaArrowUp />,
              null: <FaExchangeAlt />
            };
            
            const labels = {
              1: 'Pemasukan',
              2: 'Pengeluaran',
              null: 'Transfer'
            };
            var icon, variant;
            if(!transaction.reff_id){
                if(transaction.amount>=0){
                    icon = <FaArrowUp />
                    variant = "success"
                }else{
                    icon = <FaArrowDown />
                    variant = "danger"
                }
            }else{
                icon = <FaExchangeAlt />
                variant = "info"
            }
            
            
            return (
              <Badge bg={variant} className="d-none d-sm-block" style={{float:"left"}}>
                {icon}
              </Badge>
            );
          };
        
          // Get status badge
          getStatusBadge = (status) => {
            const variants = {
              completed: 'success',
              pending: 'warning',
              failed: 'danger'
            };
            
            const labels = {
              completed: 'Selesai',
              pending: 'Tertunda',
              failed: 'Gagal'
            };
            
            return <Badge bg={variants[status]}>{labels[status]}</Badge>;
          };

    // Method untuk mereset semua filter
    resetFilters = () => {
        this.setState({
            filter: 'all',
            assetFilter: 'all',
            categoryFilter: 'all'
        });
    }

    // Method untuk toggle tampilan filter
    toggleFilters = () => {
        this.setState(prevState => ({
            showFilters: !prevState.showFilters
        }));
    }

    FilterSection = () => {
        const asetLancar = this.getAsetLancar();
        const categories = this.props.categories;

        return (
            <Card className="mb-4 border-0 shadow-sm">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">
                            <FaFilter className="me-2 text-primary" />
                            Filter Transaksi
                        </h6>
                        <div>
                            <Button 
                                variant="outline-secondary" 
                                size="sm" 
                                onClick={this.resetFilters}
                                className="me-2"
                            >
                                Reset
                            </Button>
                            <Button 
                                variant="outline-primary" 
                                size="sm" 
                                onClick={this.toggleFilters}
                            >
                                {this.state.showFilters ? 'Sembunyikan' : 'Tampilkan'} Filter
                            </Button>
                        </div>
                    </div>

                    {this.state.showFilters && (
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <strong>Tipe Transaksi</strong>
                                    </Form.Label>
                                    <Form.Select 
                                        value={this.state.filter}
                                        onChange={(e) => this.setState({ filter: e.target.value })}
                                    >
                                        <option value="all">Semua Tipe</option>
                                        <option value="pendapatan">Pemasukan</option>
                                        <option value="pengeluaran">Pengeluaran</option>
                                        <option value="transfer">Transfer</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <strong>Aset Lancar</strong>
                                    </Form.Label>
                                    <Form.Select 
                                        value={this.state.assetFilter}
                                        onChange={(e) => this.setState({ assetFilter: e.target.value })}
                                    >
                                        <option value="all">Semua Aset</option>
                                        {asetLancar.map(asset => (
                                            <option key={asset.asset_id} value={asset.asset_id}>
                                                {asset.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <strong>Kategori</strong>
                                    </Form.Label>
                                    <Form.Select 
                                        value={this.state.categoryFilter}
                                        onChange={(e) => this.setState({ categoryFilter: e.target.value })}
                                    >
                                        <option value="all">Semua Kategori</option>
                                        {categories.map(category => (
                                            <option key={category.id} value={category.id}>
                                                {category.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                    {/* Info filter aktif */}
                    {(this.state.filter !== 'all' || this.state.assetFilter !== 'all' || this.state.categoryFilter !== 'all') && (
                        <div className="mt-3">
                            <small className="text-muted">
                                Filter aktif: 
                                {this.state.filter !== 'all' && ` Tipe: ${this.state.filter}`}
                                {this.state.assetFilter !== 'all' && `, Aset: ${asetLancar.find(a => a.asset_id === this.state.assetFilter)?.name}`}
                                {this.state.categoryFilter !== 'all' && `, Kategori: ${categories.find(c => c.id === this.state.categoryFilter)?.name}`}
                            </small>
                        </div>
                    )}
                </Card.Body>
            </Card>
        );
    }

    ListTransaksi = () =>{
        //console.log(this.props.assets)
        try{
        const filter = this.state.filter;
        const groupedTransactions = this.getGroupedTransactions();

        const total = this.calculateTotals(this.props.transactions)
        
        return (
            <Container>
                
                <Row className="mb-4">
                    <Col md={3} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                            <h6 className="card-title text-muted">Pemasukan</h6>
                            <h4 className="text-success">{this.formatCurrency(total.income)}</h4>
                            </div>
                            <div className="bg-success bg-opacity-10 p-3 rounded">
                            <FaArrowDown className="text-success" size={20} />
                            </div>
                        </div>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md={3} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                            <h6 className="card-title text-muted">Pengeluaran</h6>
                            <h4 className="text-danger">{this.formatCurrency(total.expense)}</h4>
                            </div>
                            <div className="bg-danger bg-opacity-10 p-3 rounded">
                            <FaArrowUp className="text-danger" size={20} />
                            </div>
                        </div>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md={3} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                            <h6 className="card-title text-muted">Transfer</h6>
                            <h4 className="text-info">{this.formatCurrency(total.transfer)}</h4>
                            </div>
                            <div className="bg-info bg-opacity-10 p-3 rounded">
                            <FaExchangeAlt className="text-info" size={20} />
                            </div>
                        </div>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md={3} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                            <h6 className="card-title text-muted">Saldo</h6>
                            <h4 className={total.net >= 0 ? 'text-primary' : 'text-danger'}>
                                {this.formatCurrency(total.net)}
                            </h4>
                            </div>
                            <div className="bg-primary bg-opacity-10 p-3 rounded">
                            <FaMoneyBillWave className="text-primary" size={20} />
                            </div>
                        </div>
                        </Card.Body>
                    </Card>
                    </Col>
                </Row>

                {/* Tambahkan section filter */}
                <this.FilterSection />

        <Row>
        
        {/* Daftar transaksi yang dikelompokkan berdasarkan tanggal */}
        {Object.entries(groupedTransactions)
          .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
          .map(([date, transactions]) => {
            
            const filteredTransactions = this.filterTransactions(transactions);
            const dailyTotal = this.getDailyTotal(filteredTransactions);
            
            if (filteredTransactions.length === 0) return null;
            
            return (
              <div key={date} className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3 trx-date">
                  <h5 className="text-muted mb-0">{this.formatDate(date)}</h5>
                  <Badge bg={dailyTotal >= 0 ? 'success' : 'danger'}>
                    Total: {this.formatCurrency(dailyTotal)}
                  </Badge>
                </div>
                <Card.Body className="p-0 table-responsive" key={date}>
                    <Table responsive hover className="mb-0">
                    <thead className="table-light">
                        <tr>
                        <th width="40%">Kategori</th>
                        <th width="20%" className="text-end">Jumlah</th>
                        <th width="40%" className="text-end">Metode</th>
                        </tr>
                    </thead>
                    <tbody key={date}>
                    {filteredTransactions.map(transaction => (
                        <tr key={transaction.id}  onClick={(key)=>{
                                        if(transaction.transactionType!="pencatatan"){
                                            this.editData(transaction)
                                        }else if(transaction.reff_id){
                                          //transfer
                                          this.editData(transaction)
                                        }
                                    }}>
                        <td>
                            {transaction.desc}
                            <div className="d-flex align-items-center">
                            {transaction.icon}
                            <span className="small">{transaction.category_name}</span>
                            </div>
                        </td>
                        <td className={`text-end fw-bold ${
                            transaction.amount >= 0 ? 'text-success' : 'text-danger' 
                        }`}>
                            {this.getTypeBadge(transaction)}
                            {this.formatCurrency(transaction.amount)}
                            
                        </td>
                        <td className="text-end">
                            {transaction.asset_name}
                            <div style={{fontSize:"8pt", color:"#555555ff"}}>oleh: {transaction.user_name}</div>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                    </Table>
                </Card.Body>
              </div>
            );
          })
        }

        {/* Pesan jika tidak ada transaksi */}
        {Object.keys(groupedTransactions).length === 0 && (
          <Card className="text-center py-5">
            <Card.Body>
              <i className="fas fa-receipt fa-3x text-muted mb-3"></i>
              <h5 className="text-muted">Tidak ada transaksi</h5>
              <p className="text-muted">Transaksi akan muncul di sini</p>
            </Card.Body>
          </Card>
        )}
      </Row>
      </Container>
        );
            }
            catch(e){
                //console.log(e)
            }
    }

    handleTransactionTypeSelect =(val)=>{
        this.handleShow(val)
    }

    

    render(){

          const actions = [
            { label: "Pemasukan", icon: <ArrowDown />, bgcolor:"#1cc88a", onClick:()=>this.handleShow("pendapatan")},
            { label: "Pengeluaran", icon: <ArrowUp />, bgcolor:"#e74a3b", onClick:()=>this.handleShow("pengeluaran")},
            { label: "Transfer", icon: <ArrowLeftRight />, bgcolor:"#36b9cc", onClick:()=>this.handleShow("transfer") },
          ];
        if(this.state.redirect){
            return <Navigate to={this.state.needUpdate} />
        }
        return (
            <>
            <this.CreateTransactionModal/>
                <Container className="my-5">
                    <Row className="mb-4 sub-title">
                        <Col>
                            <h2 className="d-flex align-items-center">
                                <FaMoneyBillWave className="me-2 text-primary" />
                                Daftar Transaksi 
                            </h2>
                            <p className="text-muted d-none d-sm-block">Kelola semua transaksi keuangan Anda</p>
                        </Col>
                        <Col xs="auto">
                            <ModalTransactionButtons 
                                onButtonClick={this.handleTransactionTypeSelect}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <this.ListTransaksi />
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

const mapStateToProps = state => {
    return{
        user : state.user,
        books: state.books,
        assets: state.assets,
        categories: state.categories,
        transactions: state.transactions
    }
}

const mapDispatchToProps = dispatch => {
    return{
        createTransaction: (book) => dispatch(createTransaction(book)),
        updateTransaction: (book) => dispatch(updateTransaction(book)),
        getAssets: (book) => dispatch(getAssets(book)),
        getCategories: (book) => dispatch(getCategories(book)),
    }
} 
export default connect(mapStateToProps, mapDispatchToProps)(Transactions);